import styled from "styled-components";
import { backgroundColor, largeSize, mediumSize, primaryColor, secondaryColor, tertiaryColor } from "../../styles/variables";

const ListDisplayContainer = styled.main`
background-color: ${backgroundColor};
color: ${secondaryColor};
width: 100vw;
min-height: 100vh;
font-size: 1rem;

input {
    width: 30vw;
    height: 5vh;
    margin: .5rem;
}
h3, h4 {
    margin: 1rem;
    padding: 1rem;
    font-size: 1.5rem;
    font-weight: bold;
    text-align: center;
    span {
        font-size: calc(${mediumSize} - 5px)
    }
}
.save-for-later {
    margin: 1rem;
    display: flex;
    justify-content: center;
    button {
        background-color: ${tertiaryColor};
        color: ${primaryColor};
    }
}
.check-product {
    margin-right: 1.5rem;
    width: 8vw;
    height: 8vh;
}
p {
    margin-right: 1.5rem;
    font-size: 1.5rem;
}

.calculator-button {
    position: fixed;
    top: 90%;
    right: 10%;
    z-index: 1000;
}
`;
export { ListDisplayContainer }